"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(handlers) {
    var onClick = handlers.onClick, onHide = handlers.onHide, onMouseEnter = handlers.onMouseEnter, onMouseLeave = handlers.onMouseLeave, onShow = handlers.onShow;
    var events = __assign(__assign(__assign(__assign(__assign({}, (onClick && {
        click: function (event) {
            onClick(this, event);
        }
    })), (onShow && {
        show: function () {
            onShow(this);
        }
    })), (onHide && {
        hide: function () {
            onHide(this);
        }
    })), (onMouseLeave && {
        mouseOut: function (event) {
            onMouseLeave(this, event);
        }
    })), (onMouseEnter && {
        mouseOver: function (event) {
            onMouseEnter(this, event);
        }
    }));
    return events;
}
exports.default = default_1;
//# sourceMappingURL=bindEventHandlers.js.map